export default "__VITE_ASSET__Ll72u0XQ__"